import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import LandingPage from "./components/landingPage";
import VideoPage from "./components/videoPage";
import "./App.css";

export const config = {
  endpoint: `https://xflix-backend-ilqt.onrender.com/v1`,
};

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/">
            <LandingPage />
          </Route>
          <Route path="/videos/:id">
            <VideoPage />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
